"use client";

import { useStore } from "@nanostores/react";
import { isOpteraAdmin, user } from "common/stores/UserStore";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import {
	getLocalPartEmail,
	getPersistentClaritySessionId,
} from "common/utils/auth/AuthUtils";

export default function AnalyticsTracker() {
	const $user = useStore(user);
	const pathname = usePathname();

	useEffect(() => {
		if (!window.clarity) return;
		// Report current page
		window.clarity("set", "pageUrl", window.location.href);
		window.clarity("set", "pagePath", pathname);

		// Optional: trigger custom event
		window.clarity("event", "page_view", { pathname });

		const sessionId = getPersistentClaritySessionId();
		const isAdmin = isOpteraAdmin();
		window.clarity("set", "sessionId", sessionId);
		window.clarity(
			"identify",
			$user.username,
			sessionId,
			window.location.pathname,
			getLocalPartEmail($user.username)
		);
		window.clarity("set", "organization", $user.organization);
		window.clarity("set", "user_role", isAdmin ? "optera:admin" : "client");
	}, [pathname, $user.organization, $user.username]);

	return null;
}
